import React from 'react';
import { Col, Row } from 'react-bootstrap';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { filterConfig } from '../config/filterConfig';

const ClientesFilter = ({
  loading,
  onApply
}) => <Row>
    <Col md={12}>
      <FilterPanel filters={filterConfig} onApply={onApply} title="Filtros de Clientes" loading={loading} defaultCollapsed={true} />
    </Col>
  </Row>;

export default ClientesFilter;
